import { Button } from '@mui/material';
import { AlertDialog } from 'src/components';

type Props = {
  onConfirm?: () => void;
  isOpen: boolean;
  onClose: () => void;
  text: string;
};

export const LeaveDashboardDialog = ({ onConfirm, isOpen, onClose, text }: Props) => (
  <AlertDialog
    testId="disconnect-gateway-popup"
    open={isOpen}
    onClick={onClose}
    title={''}
    customContent={<>{text}</>}
    action={
      <>
        <Button variant="outlined" data-sm="no-button" onClick={onClose}>
          No
        </Button>
        <Button variant="contained" data-sm="yes-button" onClick={onConfirm}>
          Yes
        </Button>
      </>
    }
    onClose={onClose}
  />
);
